import React, { useState, useEffect } from 'react';
import { Observer } from 'mobx-react';
import {
  Typography,
  TextField,
  Checkbox,
  Button,
  FormControlLabel,
} from '@material-ui/core';
import { Formik } from 'formik';
import { css } from '@emotion/core';
import * as yup from 'yup';
import { WideBox, FlexDiv, FormRow, StyledForm } from '../../styles/styles';

const ButtonRow = css`
  display: flex;
  button {
    margin-right: 5px;
  }
`;

const initialValues = {
  Name: '',
  UserOnly: false,
};

export const templateSchema = yup.object().shape({
  Name: yup
    .string()
    .min(2)
    .required(),
});

const SaveTemplate = ({ saveReportTemplate, handleClose }) => (
  <Formik
    initialValues={initialValues}
    validationSchema={templateSchema}
    onSubmit={async (values, actions) => {
      try {
        await saveReportTemplate(values);
        handleClose();
        actions.resetForm();
      } catch (e) {
        console.error(e);
      }
    }}
    render={({
      values,
      handleBlur,
      handleChange,
      setFieldValue,
      handleSubmit,
      dirty,
      resetForm,
      errors,
      touched,
    }) => (
      <Observer
        render={() => {
          const showError = val => errors[val] && touched[val];
          return (
            <FlexDiv
              style={{
                maxWidth: '1500px',
                width: '98%',
                alignSelf: 'center',
                padding: '1rem',
              }}
            >
              <Typography variant="h2" gutterBottom>
                Save Report Template
              </Typography>

              <StyledForm onSubmit={handleSubmit}>
                <FormRow>
                  <TextField
                    name="Name"
                    label="Template Name"
                    margin="normal"
                    value={values.Name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="outlined"
                    type="text"
                    fullWidth
                    error={showError('Name')}
                  />
                </FormRow>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!values.UserOnly}
                      onChange={(e, val) => {
                        setFieldValue('UserOnly', val);
                      }}
                      value={values.UserOnly}
                    />
                  }
                  label="Visible Only to Me"
                />

                <div css={ButtonRow}>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={!dirty}
                  >
                    Save As Template
                  </Button>
                </div>
              </StyledForm>
            </FlexDiv>
          );
        }}
      />
    )}
  />
);

export default SaveTemplate;
